// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NotFound_container__aMqYL {
  margin: 5%;
  height: 544px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 5px 20px rgba(181, 181, 181, 0.25);
}
.NotFound_container__aMqYL .NotFound_image__vt5OK {
  width: 330px;
}
.NotFound_container__aMqYL .NotFound_containerInfo__ewzc9 {
  width: 40%;
  margin: 3%;
}
.NotFound_container__aMqYL .NotFound_containerInfo__ewzc9 .NotFound_title__u4rJJ {
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 15px;
}
.NotFound_container__aMqYL .NotFound_containerInfo__ewzc9 .NotFound_info__wbD4s {
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/NotFound/NotFound.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAEA;EACE,UAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kDAAA;AADF;AAEE;EACE,YAAA;AAAJ;AAEE;EACE,UAAA;EACA,UAAA;AAAJ;AACI;EACE,iBCTC;EDUD,eCZK;EDaL,mBAAA;AACN;AACI;EACE,eCnBG;ADoBT","sourcesContent":["@use \"styles/colors\";\n@use \"styles/typography\";\n.container {\n  margin: 5%;\n  height: 544px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 5px 20px rgba(181, 181, 181, 0.25);\n  .image {\n    width: 330px;\n  }\n  .containerInfo {\n    width: 40%;\n    margin: 3%;\n    .title {\n      font-weight: typography.$bold;\n      font-size: typography.$header-m;\n      margin-bottom: 15px;\n    }\n    .info {\n      font-size: typography.$body-l;\n    }\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NotFound_container__aMqYL`,
	"image": `NotFound_image__vt5OK`,
	"containerInfo": `NotFound_containerInfo__ewzc9`,
	"title": `NotFound_title__u4rJJ`,
	"info": `NotFound_info__wbD4s`
};
export default ___CSS_LOADER_EXPORT___;
